import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProductModel from '../../models/ProductModel';
import { dicNames, i18n } from '../../lang/i18n';
import { Rating } from 'react-simple-star-rating';

export enum ProductForListTypes {
    OnlyImage,
    Small,
    Medium,
    Full,
    Search
}

interface Props {
    locationCode: string,
    product: ProductModel,
    type?: ProductForListTypes,
    buttonAdd?: boolean
}

export default function ProductForList(props: Props) {
    const type = props.type ?? ProductForListTypes.Small;
    const product = props.product;
    const navigate = useNavigate();

    switch (type) {
        case ProductForListTypes.Search:
            return <div className="autocomplete-item row">
                <div className="col-2">
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                        <img src={product.photo.url250} alt={product.title} />
                    </Link>
                </div>
                <div className="col-10" style={{ textAlign: 'left' }}>
                    <div className="product-fl-price">
                        <span className="price">{product.price}€</span>
                    </div>
                    <div className="product-fl-title-2l">
                        <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                            {product.title}
                        </Link>
                    </div>
                </div>
            </div>
        case ProductForListTypes.OnlyImage:
            return <div className="product-fl">
                <div className="product-fl-image">
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                        <img src={product.photo.url250} alt={product.title} />
                    </Link>
                </div>
            </div>
        case ProductForListTypes.Small:
            return <div className="product-fl">
                <div className="product-fl-image">
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                        <img src={product.photo.url250} alt={product.title} />
                    </Link>
                </div>
                <div className="product-fl-title-2l">
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                        {product.title}
                    </Link>
                </div>
                <div className="marin-bottom-auto"></div>
                <div className="product-fl-price">
                    <span className="price">{product.price}€</span>
                    {product.priceOld > 0 && <del><small>{product.priceOld.toFixed(1)}€</small></del>}
                </div>
                {props.buttonAdd && <div className="text-center mb-3">
                    <button type="button" className="btn btn-success btn-sm">{i18n._BTNs.AddToChar}</button>
                </div>}
            </div>
        case ProductForListTypes.Medium:
            return <div className="product-fl">
                <div className="product-fl-image">
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                        <img src={product.photo.url250} alt={product.title} />
                    </Link>
                </div>
                <div className="product-fl-title-3l">
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                        {product.title}
                    </Link>
                </div>
                <div className="marin-bottom-auto"></div>
                <div className="product-fl-price">
                    <span className="price">{product.price}€</span>
                    {product.priceOld > 0 && <del><small>{product.priceOld.toFixed(1)}€</small></del>}
                </div>
                {props.buttonAdd && <div className="text-center mb-3">
                    <button type="button" className="btn btn-success btn-sm">{i18n._BTNs.AddToChar}</button>
                </div>}
            </div>
        case ProductForListTypes.Full:
            return <div className="product-fl" onClick={() => navigate("/" + props.locationCode + "/product/" + product.productCode)}>
                <div className="product-fl-image" style={{ backgroundImage: `url(${product.photo.url250})` }}>
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                    </Link>
                </div>
                <div className="product-fl-title">
                    <Link to={"/" + props.locationCode + "/product/" + product.productCode} className="link-dark">
                        {product.title}
                    </Link>
                    <div>
                        {product.tags.map((item: string, index: number) => (
                            <span className="badge badge-light mr-1" key={index}>{item}</span>
                        ))}
                    </div>
                    <div>
                        {product.allergens && product.allergens.map((item: string, index: number) => (
                            <span className="badge badge-pill badge-warning mr-1" key={index}>{dicNames[item]}</span>
                        ))}
                    </div>
                </div>
                <div className="marin-bottom-auto"></div>
                <div className="product-fl-price">{product.price}€
                    {product.priceOld > 0 && <del><small> {product.priceOld.toFixed(1)}€</small></del>}</div>
                {product.rating > 0 && <div className='text-center'><Rating readonly={true} size={17} initialValue={product.rating} /></div>}
                {props.buttonAdd && <div className="text-center mb-3">
                    <button type="button" className="btn btn-success btn-sm">{i18n._BTNs.AddToChar}</button>
                </div>}
            </div>
        default:
            return <></>
    }
}

